import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'
import { Box } from '@mui/material'

import { Carousel, SliderButton } from '@/components/Carousel/Carousel'
import { ImageWithPlaceholder } from '@/components/ui/tailwind/ImageWithPlaceholder'
import { getGalleryImages, ProductImageFormat } from '@/helpers/productImages'

import type React from 'react'
import type { ProductProps } from '@/interfaces/product.interface'

interface ProductDetailsCarouselProps {
  product: ProductProps
}
export const ProductDetailsCarousel: React.FC<ProductDetailsCarouselProps> = ({ product }) => {
  const slideImages = getGalleryImages(product?.images, ProductImageFormat.gallery)
  const navigationImages = getGalleryImages(product?.images, ProductImageFormat.thumbnail100)

  if (slideImages.length === 0) {
    return null
  }

  return (
    <Carousel
      sx={{ padding: 0 }}
      pageDetails
      items={slideImages.map((imageData, idx) => (
        <ImageWithPlaceholder
          key={imageData.galleryIndex ?? idx}
          src={imageData.url ?? ''}
          alt={imageData.altText}
          loading="lazy"
          fill
          style={{ objectFit: 'contain' }}
        />
      ))}
      settingsOverride={{
        customPaging: (i) => {
          return (
            <Box>
              <ImageWithPlaceholder
                src={navigationImages[i]?.url}
                loading="lazy"
                fill
                style={{ objectFit: 'contain' }}
                alt={navigationImages[i]?.altText}
              />
            </Box>
          )
        },
        prevArrow: (
          <SliderButton data-qa="carousel-buttonPrevious">
            <ArrowBackIos sx={{ height: 23, width: 23 }} color="secondary" fontSize="small" />
          </SliderButton>
        ),
        nextArrow: (
          <SliderButton data-qa="carousel-buttonNext">
            <ArrowForwardIos sx={{ height: 23, width: 23 }} color="secondary" fontSize="small" />
          </SliderButton>
        ),
        speed: 1000,
      }}
    />
  )
}
